module.exports = __webpack_public_path__ + "img/logo-qstorage.04514b9b.png";